import { Style } from "./Style";

let defaultStyle;

export class TextStyle extends Style {
    static get DEFAULT() {
        return defaultStyle || (defaultStyle = new TextStyle);
    }
    constructor(style = {}, bodyStyle = {}) {
        var _a, _b;
        super(style, bodyStyle), this._autoWrapText = null !== (_a = null == style ? void 0 : style.autoWrapText) && void 0 !== _a ? _a : null == bodyStyle ? void 0 : bodyStyle.autoWrapText, 
        this._lineClamp = null !== (_b = null == style ? void 0 : style.lineClamp) && void 0 !== _b ? _b : null == bodyStyle ? void 0 : bodyStyle.lineClamp;
    }
    clone() {
        return new TextStyle(this, null);
    }
    get lineClamp() {
        return this._lineClamp;
    }
    set lineClamp(lineClamp) {
        this._lineClamp = lineClamp;
    }
    get autoWrapText() {
        return this._autoWrapText;
    }
    set autoWrapText(autoWrapText) {
        this._autoWrapText = autoWrapText;
    }
}
//# sourceMappingURL=MultilineTextStyle.js.map
